/**
 * Stat and keyword icon URLs (Riot asset CDN).
 * Base: riot-glyphs/rb/latest — might.svg, card_type_rune.svg (power), exhaust.svg.
 * Used for stats and for inline :rb_might: / :rb_power: / :rb_exhaust: in card text.
 */
const GLYPH_BASE = 'https://assetcdn.rgpub.io/public/live/riot-shared/player-experiences/riot-glyphs/rb/latest';

export const MIGHT_ICON_URL = `${GLYPH_BASE}/might.svg`;
export const POWER_ICON_URL = `${GLYPH_BASE}/card_type_rune.svg`;
export const EXHAUST_ICON_URL = `${GLYPH_BASE}/exhaust.svg`;
export const RUNE_RAINBOW_ICON_URL = `${GLYPH_BASE}/rune_rainbow.svg`;

/** Energy cost tokens :rb_energy_0: through :rb_energy_8: */
const ENERGY_ICON_URLS = Object.fromEntries(
  [0, 1, 2, 3, 4, 5, 6, 7, 8].map((n) => [`energy_${n}`, `${GLYPH_BASE}/energy_${n}.svg`])
);
export const ENERGY_ICON_URL = `${GLYPH_BASE}/energy_0.svg`;

/** Token name (e.g. from :rb_rune_rainbow:, :rb_energy_0:) → icon URL for inline card text. Returns null if no icon. */
export function getTokenIconUrl(tokenName) {
  const key = (tokenName || '').toLowerCase();
  if (key === 'might') return MIGHT_ICON_URL;
  if (key === 'power') return POWER_ICON_URL;
  if (key === 'exhaust') return EXHAUST_ICON_URL;
  if (key === 'rune_rainbow') return RUNE_RAINBOW_ICON_URL;
  if (ENERGY_ICON_URLS[key]) return ENERGY_ICON_URLS[key];
  return null;
}
